<template>
  <div>
    <div class="flex flex-wrap justify-center">
      <div
        v-for="(list, index) in homeData"
        class="px2">
        <router-link class="inline-block relative bb-pointer" :to="{name:
        'Home', params: { id: list.value._id, name: list.doc.name}}">
          <div class="inline-block relative bb-pointer"
            @mouseenter="hoverTab(index + 1)"
            @mouseleave="resetHoverTab()">
            <div class="mt1 mb2 bb-fs1pt13 bb-sm-fs1pt5 bb-fc1"
              :class="[ listId === list.value._id ? 'bb-ff3' : 'bb-ff2' ]">
              {{list.doc.name}}
            </div>
            <div class="absolute bottom-0 bb-hcr bb-w3 bb-h0pt2 bb-bc2"
              v-show="listId === list.value._id"></div>
            <div class="absolute bottom-0 left-0 right-0 bb-h0pt2 bb-bc2 bb-scaleX-0 bb-transition2"
              :class="[ hoveredIndex === (index + 1) ? 'bb-scaleX-1' : 'bb-scaleX-0' ]"></div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="bb-fullscreen relative bb-h28 bb-lg-h25 mt2 mb3">
      <img class="absolute bb-vhcr bb-w5 bb-h5" v-if="!playlistItems || !sliderRender"
        src="../assets/images/loader.svg"></img>
      <slider v-if="playlistItems" v-show="sliderRender" :sliderData="playlistItems"
        v-on:emitSlidePosterClicked="recieveSlidePosterClicked"
        v-on:sliderRenderFinished="sliderReady"></slider>
    </div>
    <div>
      <router-link class="block col-10 lg-col-2 bb-max-w34 mx-auto
      text-decoration-none" v-if="listId" :to="{ name: 'Booking', params: {
        playlistId: listId, playlistName: listName}}">
        <div class="center bb-h2pt5 bb-py1pt25 bb-lh0 border-box bb-pointer bb-fc1 bb-sm-fc2 bb-fc1-hover
          bb-bc2 bb-sm-bc-transp bb-bc2-hover bb-ff3 bb-fs1 bb-brd3"
          :class="[ bookSessionTransitionClass, bookSessionHighlighted ? 'bb-scale-1pt1' : '' ]">
          {{ $lang.messages.book_session}}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import slider from '@/components/slider'

export default {
  name: 'Home',
  components: {
    'slider': slider
  },
  data () {
    return {
      bookSessionHighlighted: false,
      bookSessionTransitionClass: 'bb-transition2',
      hoveredIndex: 0,
      sliderRender: false,
    }
  },
  methods: {
    highlightBookSession: function () {
      this.bookSessionHighlighted = true
      var self = this
      setTimeout(function () {
        self.bookSessionHighlighted = false
      }, this.$utilities.getTransitionDurationOfClass('.' + this.bookSessionTransitionClass) * 1000)
    },
    recieveSlidePosterClicked: function () {
      this.highlightBookSession()
    },
    loadListId: function () {
      this.$store.commit('SET_ITEMS', null)
      this.sliderRender = false 
      if (this.listId) {
        this.$store.dispatch('LOAD_ITEMS', this.listId)
      }
    },
    hoverTab: function (index) {
      this.hoveredIndex = index
    },
    resetHoverTab: function () {
      this.hoveredIndex = 0
    },
    sliderReady: function () {
      this.sliderRender = true
    }
  },
  computed: {
    homeData () {
      return this.$store.getters.getHomeData
    },
    listId () {
      if (this.$route.params.id) {
        return this.$route.params.id
      }

      if (this.homeData && this.homeData.length) {
        return this.homeData[0].value._id
      }

      return ''
    },
    listName () {
      if (this.$route.params.name) {
        return this.$route.params.name
      }

      if (this.homeData && this.homeData.length) {
        return this.homeData[0].doc.name
      }

      return ''
    },
    playlistItems () {
      return this.$store.getters.getItems
    }
  },

  watch: {
    'listId': {
      handler: 'loadListId',
      immediate: true
    }
  },

  created () {
    /* this component is re-initialized everytime a new tab
       is selected, and there is no point reloading the actual
       schedule */
    if (!this.homeData) {
      this.$store.dispatch('LOAD_SCHEDULE', 'home')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home.vue